const DEFAULT_HEADERS = [
  "Payment Methods",
  "Number of Order/ Transactions",
  "Total Value",
];

function ReportingSummaryTable({ rows, headers = DEFAULT_HEADERS }) {
  return (
    <div className="overflow-hidden rounded-md border border-cblack6">
      <div className="grid grid-cols-[1.4fr_1fr_1fr] bg-cblack6 px-4 py-3 text-sm font-semibold text-cwhite">
        <span>{headers[0]}</span>
        <span className="text-center">{headers[1]}</span>
        <span className="text-right">{headers[2]}</span>
      </div>
      <div>
        {rows.map((row, index) => (
          <div
            key={`${row.label}-${index}`}
            className={`grid grid-cols-[1.4fr_1fr_1fr] items-center px-4 py-3 text-sm ${
              row.highlight ? "text-cyellow font-semibold" : "text-white"
            } ${
              row.dividerTop
                ? "border-t border-dashed border-color4"
                : "border-t border-cblack6"
            }`}
          >
            <span>{row.label}</span>
            <span className="text-center">{row.count}</span>
            <span className="text-right">{row.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ReportingSummaryTable;
